import React, { Component } from 'react';
import { FormLayout, SelectQuery } from '@/components';
import { DatePicker, Select, Form } from 'antd';
import Api from '@/services';
import { judgeArr } from '@/shared/functions';
import { dispatch } from '@@/store';
const { Option } = Select;
class TopForm extends Component {
    constructor(props) {
        super(props);
        this.search = (data) => {
            // 处理时间为 创建时间开始：createTimeBegin 创建时间结束：createTimeEnd
            const searchData = JSON.parse(JSON.stringify(data));
            if (data.time !== void 0) {
                searchData.createTimeBegin = data.time[0];
                searchData.createTimeEnd = data.time[1];
                delete searchData.time;
            }
            dispatch.groupMoneyManage.SET_STATE({
                searchData,
                currentIndex: 1,
            });
            dispatch.groupMoneyManage.load({});
        };
        this.state = { options: [] };
    }
    componentWillMount() {
        Api.base.getKeyValue({ typeId: 30 })
            .then((_r) => {
            if (judgeArr(_r)) {
                const _d = JSON.parse(JSON.stringify(_r)).map((item) => {
                    return {
                        label: item.value,
                        value: item.keyName,
                    };
                });
                this.setState({
                    options: _d,
                });
            }
        });
    }
    render() {
        const { getFieldDecorator } = this.props.form;
        const { options } = this.state;
        return (<FormLayout form={this.props.form} onSearch={this.search}>
        <Form.Item label={'时间'} className={'width-100'}>
          {getFieldDecorator('time', {
            initialValue: [],
        })(<DatePicker.RangePicker className={'width-100'} getCalendarContainer={(triggerNode) => {
            return triggerNode.parentNode;
        }}/>)}
        </Form.Item>
        <Form.Item label={'明细类型'}>
          {getFieldDecorator('type', { initialValue: '' })(<Select placeholder="请选择明细类型">
                <Option value={''}>全部</Option>
                {options.map((opt, i) => (<Option key={`opt_${i}`} value={opt.value}>{opt.label}</Option>))}
              </Select>)}
        </Form.Item>
        <Form.Item label={'卖家经销商'}>
          {getFieldDecorator('shopCode')(<SelectQuery labelInValue={false}/>)}
        </Form.Item>
      </FormLayout>);
    }
}
const Top = Form.create()(TopForm);
export default Top;
